<div
  class="page-container responsive-height topspaces"
  *ngrxLet="sharedFacade.isLoaded$ as dataLoaded"
>
  <div class="page-content">
    <div class="container-fluid">
      <div class="piqetprofilepage-main">
        <div class="profileuser-navbars">
          <div class="profile-sidebar">
            <div class="portlet light profile-sidebar-portlet">
              <ng-container>
                <ng-container *ngrxLet="UserDetailsFacade.profileData$ as profileData">
                  <ng-container *ngrxLet="UserDetailsFacade.userProfileImage$ as userProfileImage">
                    <div class="profile-maindiv">
                      <div class="profile-userpic profile" *ngIf="userProfileImage">
                        <img [src]="image" class="img-responsive" />
                      </div>
                      <ng-container
                        *ngrxLet="UserDetailsFacade.userProfileOverview$ as userProfileOverview"
                      >
                        <div
                          class="profile-userpic profile"
                          [ngStyle]="{ 'background-color': 'black' }"
                          *ngIf="!userProfileImage"
                        >
                          <span class="initials">
                            {{ userProfileOverview?.firstName?.charAt(0)
                            }}{{ userProfileOverview?.lastName?.charAt(0) }}
                          </span>
                        </div>
                        <div class="profile-usertitle">
                          <div class="profile-usertitle-name">
                            <p>{{ userProfileOverview?.firstName }}</p>
                            <p>{{ userProfileOverview?.lastName }}</p>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <div class="profile-usermenu">
                <ul class="nav">
                  <li [ngClass]="isOverview ? 'active' : ''">
                    <a (click)="changeMenu('Overview')">
                      <!-- <i class="fa fa-eye fa-lg" aria-hidden="true"></i>Account Overview -->
                      <img src="assets/images/Account icon.png" class="fix-image" />
                      <p class="menutext">Account overview</p>
                    </a>
                  </li>
                  <li [ngClass]="isPersonalInfo ? 'active' : ''">
                    <a (click)="changeMenu('personalInfo')">
                      <!-- <i class="fa fa-user-secret fa-lg"></i> Personal Information -->
                      <img src="assets/images/Person icon.png" class="fix-image" />
                      <p class="menutext">Personal information</p>
                    </a>
                  </li>
                  <!-- <li [ngClass]="isChangeProfileImg ? 'active' : ''">
                                            <a (click)="changeMenu('changeProfileImg')">
                                                <img src="assets/images/Person icon.png" class="fix-image">Change Profile Image
                                            </a>
                                        </li> -->
                  <li [ngClass]="isChangePassword ? 'active' : ''">
                    <a (click)="changeMenu('changePassword')">
                      <!-- <i class="fa fa-keyboard-o fa-lg"></i>Security -->
                      <img src="assets/images/Security icon.png" class="fix-image" />
                      <p class="menutext">Security</p>
                    </a>
                  </li>
                  <li [ngClass]="isEmailPreferences ? 'active' : ''">
                    <a (click)="changeMenu('emailPreferences')">
                      <!-- <i class="fa fa-envelope-square fa-lg"></i>Preferences -->
                      <img src="assets/images/Preferences icon.png" class="fix-image" />
                      <p class="menutext">Preferences</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="navbars-details-page">
          <div *ngIf="isOverview">
            <ng-container *ngrxLet="UserDetailsFacade.userProfileOverview$ as userProfileOverview">
              <piqet-angular-profile-overview [userProfileOverview]="userProfileOverview">
              </piqet-angular-profile-overview>
            </ng-container>
          </div>
          <div *ngIf="isPersonalInfo && dataLoaded">
            <ng-container
              *ngrxLet="{
                userPersonalData: (UserDetailsFacade.userPersonalInfo$ | async),
                countryList: (sharedFacade.countryList$ | async),
                image: (UserDetailsFacade.userProfileImage$ | async)
              } as data"
            >
              <piqet-angular-personal-info
                [userPersonalData]="data.userPersonalData"
                [countryList]="data.countryList"
                (getStatesEvent)="getStatesById($event)"
                [getStatesList]="stateList"
                [imageData]="image"
                (savePersonalData)="savePersonalInfo($event)"
                (imageForMainProfile)="imageForMainProfile($event)"
                (updateUserProfileImage)="updateUserProfileImage($event)"
              >
              </piqet-angular-personal-info>
            </ng-container>
          </div>
          <!-- <div *ngIf="isChangeProfileImg">
                            <ng-container *ngrxLet="UserDetailsFacade.userProfileImage$ as userProfileImage">
                                <piqet-angular-change-profile-img [userProfileImage]="userProfileImage" (updateUserProfileImage)="updateUserProfileImage($event)">
                                </piqet-angular-change-profile-img>
                            </ng-container>
                        </div> -->
          <div *ngIf="isChangePassword">
            <ng-container *ngrxLet="UserDetailsFacade.userProfileOverview$ as userProfileOverview">
              <piqet-angular-change-password
                [userProfileOverview]="userProfileOverview"
                (changePassword)="changePassword($event)"
              ></piqet-angular-change-password>
            </ng-container>
          </div>
          <div *ngIf="isEmailPreferences">
            <ng-container
              *ngrxLet="UserDetailsFacade.getUserEmailPreferences$ as getUserEmailPreferences"
            >
              <piqet-angular-email-preferences
                [getUserEmailPreferences]="getUserEmailPreferences"
                (UpdateUserEmailPreferences)="UpdateUserEmailPreferences($event)"
              >
              </piqet-angular-email-preferences>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row margin-top-10"></div>
    </div>
  </div>
</div>
